<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>培训班数据</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
        <myTableSearch :isOperate="true" :operateWidth="376" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6" ref="tableRef" dataRow="rows">
			<template slot="integrityGradeName" slot-scope="scope">
				<img 
					v-if="getIntegrityGradeIcon(scope.row.integrityGradeName)" 
					:src="getIntegrityGradeIconSrc(scope.row.integrityGradeName)"
					style="width: 20px; height: 20px;"
					alt=""
				/>
				<span v-else>-</span>
			</template>
				<template slot="operate" slot-scope="scope">
					<el-button type="text" @click="handleView(scope.row)">详情</el-button>
                    <el-button type="text" @click="handleTeam(scope.row)">计划</el-button>
                    <el-button type="text" @click="handleTeacher(scope.row)">教师</el-button>
                    <el-button type="text" @click="handleTeachingPoint(scope.row)">学员</el-button>
                    <el-button type="text" @click="handleTrainingProgram(scope.row)">签到</el-button>
				</template>
			</myTableSearch>
       </div>
       <ClassDetail ref="classDetailRef"  :isDialog="isDetailDialog" :title="detailTitle"  :classId="classId" />
       <TeachingPlan ref="teachingPlanRef"  :isDialog="isPlanDialog" :title="planTitle"  :classId="classId" />
       <Student ref="studentRef"  :isDialog="isStudentDialog" :title="studentTitle"  :classId="classId" />
       <Teacher ref="teacherRef"  :isDialog="isTeacherDialog" :title="teacherTitle"  :classId="classId" />
       <SignIn ref="signInRef"  :isDialog="isSignInDialog" :title="signInTitle"  :classId="classId" />
    </div>
</template>

<script>
import '@/assets/css/base.css'
import {getTrainingClassList} from '@/api/training'
import { getListByDictType } from '@/api/sys/dictData'
import ClassDetail from '../components/classDetail.vue';
import TeachingPlan from '../components/teachingPlan.vue';
import Student from '../components/student.vue';
import Teacher from '../components/teacher.vue';
import SignIn from '../components/signIn.vue';

import refreshIcon from '@/assets/pages/appointment/refresh.png'


export default {
    name: 'PolicyList',
    components: {
        ClassDetail,
        TeachingPlan,
        Student,
        Teacher,
        SignIn
	},
    data() {
        return {
			refreshIcon,
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			isDetailDialog: false,
			isPlanDialog: false,
			isStudentDialog: false,
			isTeacherDialog: false,
			isSignInDialog: false,
            detailTitle: '', // 详情弹窗标题
            planTitle: '', // 计划弹窗标题
            studentTitle: '', // 学员弹窗标题
            teacherTitle: '', // 老师弹窗标题   
            signInTitle: '', // 签到弹窗标题
            classId: '',
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			isSubscribeDialog: false,//新增/编辑/查看机构弹窗
			isEdit: false,//是否为编辑模式
			isView: false,//是否为查看模式
			editData: {},//编辑/查看时的数据
			isImportResultDialog: false,//导入结果弹窗
			importResultData: '',//导入结果
			formData: [
                {
                    label:'统一社会信用代码',
                    type: 'input',
                    key: 'institutionId',
                    colLg: 6,
                    placeholder: '统一社会信用代码'
                },
				{
					label: '机构名称',
					type: 'input',
					key: 'institutionName',
					colLg: 6,
					placeholder: '机构名称'
				},
                {
                    label: '班级编号',
                    type: 'input',
                    key: 'classId',
                    colLg: 6,
                    placeholder: '班级编号'
                },
                {
                    label: '班级名称',
                    type: 'input',
                    key: 'className',
                    colLg: 6,
                    placeholder: '班级名称'
                },
				{
					label: '学期',
					type: 'daterange',
                    startDate: '开始日期',
                    endDate: '结束日期',
					key: 'verificationYear',
					colLg: 7,
					format: 'yyyy-MM-dd'
				}
			],
			tableLabel: [
                {
                    prop: 'institutionId',
                    label: '统一社会信用代码',
                    minWidth: 150
                },
                {
					prop: 'institutionName',
					label: '培训机构',
					minWidth: 200
				},
                {
                    prop: 'classId',
                    label: '班级编号',
                    minWidth: 150
                },
				{
					prop: 'className',
					label: '班级名称',
					minWidth: 150
				},
                {
                    prop: 'projectName',
                    label:'培训项目',
                    minWidth: 150
                },
				{
					prop: 'projectLevel',
					label: '等级',
					width: 150
				},
				{
					prop: 'subsidyType',
					label: '培训类型',
					width: 120
				},
				{
					prop: 'studentCount',
					label: '学员数',
					minWidth: 150
				},
				{
					prop: 'startDate',
					label: '开始日期',
					minWidth: 200
				},
                {
                    prop: 'endDate',
                    label: '结束日期',
                    minWidth: 200
                }
			],
		}
    },
    mounted() {
        this.loadIntegrityGradeData()
    },
    methods: {
		// 获取列表数据
		queryFn(queryParams) {
			return getTrainingClassList(queryParams)
		},
		// 获取诚信等级字典
		async loadIntegrityGradeData() {
			const res = await getListByDictType('cultivate_institution_integrity_grade')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithIntegrityGrade(res.data)
			}
		},
		// 更新诚信等级下拉选项
		updateFormDataWithIntegrityGrade(gradeData) {
			if (!gradeData) return

			const gradeIndex = this.formData.findIndex(item => item.key === 'integrityGradeCode')
			if (gradeIndex !== -1) {
				// 在数据开头添加"全部"选项
				const dataWithAll = [
					{
						dictLabel: '全部',
						dictValue: ''
					},
					...gradeData
				]
				this.$set(this.formData[gradeIndex], 'data', dataWithAll)
			}
		},
		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 刷新列表
		handleRefresh() {
			this.queryParams.pageNum = 1;
			this.currentPage = 1;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
		// 根据诚信等级名称获取对应的图标文件名
		getIntegrityGradeIcon(gradeName) {
			if (!gradeName) return ''
			const upperName = String(gradeName).toUpperCase()
			if (upperName.includes('A')) {
				return 'rankA'
			} else if (upperName.includes('B')) {
				return 'rankB'
			} else if (upperName.includes('C')) {
				return 'rankC'
			}
			return ''
		},
		// 获取图标路径
		getIntegrityGradeIconSrc(gradeName) {
			const iconName = this.getIntegrityGradeIcon(gradeName)
			if (!iconName) return ''
			return require(`@/assets/images/custom-icons/${iconName}.svg`)
		},
		// 查看详情
		handleView(row) {
			console.log('查看详情', row)
			this.isDetailDialog = true
            this.detailTitle = `${row.className}-班级信息`
            this.classId = row.classId
			this.$refs.classDetailRef.openDialog(row)
		},
		// 计划
		handleTeam(row) {
			console.log('查看计划', row)
			this.isPlanDialog = true
            this.planTitle = `${row.className}-培训班授课计划`
            this.classId = row.classId
			this.$refs.teachingPlanRef.openDialog(row)
		},
		// 学员
		handleTeachingPoint(row) {
			console.log('查看学员', row)
			this.isStudentDialog = true
            this.studentTitle = `${row.className}-班级学员`
            this.classId = row.classId
			this.$refs.studentRef.openDialog(row)
		},
        // 老师
        handleTeacher(row) {
            console.log('查看老师', row)
            this.isTeacherDialog = true
            this.teacherTitle = `${row.className}-班级老师`
            this.classId = row.classId
            this.$refs.teacherRef.openDialog(row)
        },
		// 签到
		handleTrainingProgram(row) {
			console.log('查看签到', row)
			this.isSignInDialog = true
            this.signInTitle = `${row.className}-班级签到`
            this.classId = row.classId
            this.$refs.signInRef.openDialog(row)
		},
	},
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding-bottom: 24px;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        padding: 0 24px;
        
        /deep/.myTableSearch {
            padding: 0;
        }
    }
}

.link-text {
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}

.toolbar-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .toolbar-icon {
        width: 24px;
        height: 24px;
    }

    .add-icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .toolbar-left {
        display: flex;
        align-items: center;
        gap: 12px;
		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;
		}
        .list-title {
            font-size: 14px;
            font-weight: 400;
            color:var(--vt-c-blue-soft);
        }
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .import-upload {
            display: inline-block;
            
            /deep/.el-upload {
                display: inline-block;
            }
        }

        .el-button {
            height: 36px;
            padding: 0 16px;
        }
    }
}
</style>